import React from 'react'
import clubLogoImg from "../../../assets/images/SportMingleLogoMark.png";
import { MdVerifiedUser } from "react-icons/md";
import { FaClock } from "react-icons/fa6";
import { IoMdCloseCircle } from "react-icons/io";


const OrganizationItem = ({ club }) => {
    return (
        <div className='sm_organization_item_container'>
            <div className='sm_organization_item_circle1'></div>
            <div className='sm_organization_item_circle2'></div>
            <div className='sm_organization_item_details_con'>
                <img src={club?.clubLogo ? `${import.meta.env.VITE_APP_BASE_URL}/club/club-logo-img/${club?.clubLogo}` : clubLogoImg} alt="" />
                <div className='sm_organization_item_details'>
                    <h1>{club?.clubName}</h1>
                    {club?.requestStatus == "APPROVED" &&
                        <h2><MdVerifiedUser className='sm_organization_item_details_verify_icon' />{club?.requestStatus}</h2>
                    }
                    {club?.requestStatus == "PENDING" &&
                        <h2><FaClock className='sm_organization_item_details_verify_icon' />{club?.requestStatus}</h2>
                    }
                    {club?.requestStatus == "REJECTED" &&
                        <h2><IoMdCloseCircle className='sm_organization_item_details_verify_icon' />{club?.requestStatus}</h2>
                    }
                </div>
            </div>
        </div>
    )
}

export default OrganizationItem